import React from "react";

const ApprovalStatusBadge = ({ status }) => {
  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "bg-yellow-100 text-yellow-800";
      case "Approved":
        return "bg-green-100 text-green-800";
      case "Rejected":
        return "bg-red-100 text-red-800";
      case "Canceled":
        return "bg-gray-200 text-gray-800";
      case "Draft":
        return "bg-gray-100 text-gray-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusClass(
        status
      )}`}
    >
      {status}
    </span>
  );
};

export default ApprovalStatusBadge;
